module.exports = __webpack_public_path__ + "static/media/Kang Jen Wee.64ebfeb8.png";